import {
  CHANGE_EVENT,
  CREATE_FORM_OBJ,
  GOOGLE_ADDRESS,
  ONBOARD_STATUS,
  ONBOARD_ERROR,
  CHECK_FORM,
  CHECK_PHONE_STATUS,
  GET_FIELDS,
  UPDATE_COUNTY_FIELD,
  ORG_CREATE_TRIGGERED,
  ONBOARD_ALERT,
  ONBOARD_ERROR_CLOSE,
  UPDATE_OPTIONS_TO_FIELDS,
  RESET_FORM_FIELDS,
  RESET_FIELD_OPTIONS
} from "./action-types";
import initState from "./form-state";
import STEPPER_FORM from "../config/stepper-form";
import cloneDeep from "lodash.clonedeep";

function createOrUpdateForm(state, payload) {
  const fromObj = state.hasOwnProperty(payload) ? state[payload] : { [payload]: {} };
  return { ...state, ...fromObj, ...{ currentForm: payload } };
}

function updateForm(state, payload) {
  const newState = {};
  const form = document.getElementById("sisp-form");
  newState[state.currentForm] = {
    ...state[state.currentForm],
    ...{ [payload.key]: payload.value },
  };
  return { ...state, ...newState, ...{ formValidity: form.checkValidity() } };
}

function resetDataForm(state, payload) {
  const newState = {};
  const form = document.getElementById("sisp-form");
  newState[state.currentForm] = {
    ...state[state.currentForm],
    ...payload,
  };
  return cloneDeep({ ...state, ...newState, ...{ formValidity: form.checkValidity() } });
}

function googleAddUpdate(state, payload) {
  const newState = {};
  newState[state.currentForm] = {
    ...state[state.currentForm],
    ...payload,
  };
  return { ...state, ...newState };
}

function onBoardStatus(state, payload) {
  return {
    ...state,
    ...{ onBoardedStatus: true, onBoardDetails: payload },
  };
}

function checkPhoneStatus(state, status) {
  return { ...state, ...{ phoneValidity: status } };
}

function checkFormStatus(state) {
  const form = document.getElementById("sisp-form");
  return { ...state, ...{ formValidity: form.checkValidity() } };
}

export default function reduxFormReducer(state = initState, action) {
  switch (action.type) {
    case CREATE_FORM_OBJ:
      return createOrUpdateForm(state, action.payload);
    case CHANGE_EVENT:
      return updateForm(state, action.payload);
    case RESET_FORM_FIELDS:
      return resetDataForm(state, action.payload);
    case RESET_FIELD_OPTIONS:
      return resetFieldsOptions(state, action.payload);
    case GOOGLE_ADDRESS:
      return googleAddUpdate(state, action.payload);
    case ONBOARD_STATUS:
      return onBoardStatus(state, action.payload);
    case ONBOARD_ERROR:
      return { ...state, onBoardError: action.payload };
    case ONBOARD_ERROR_CLOSE:
      return { ...state, onBoardError: false };
    case ONBOARD_ALERT:
      return { ...state, ...action.payload };
    case CHECK_FORM:
      return checkFormStatus(state);
    case CHECK_PHONE_STATUS:
      return checkPhoneStatus(state, action.payload);
    case ORG_CREATE_TRIGGERED:
      return { ...state, reqtriggered: action.payload };
    default:
      return state;
  }
}

export function fieldReducer(state = STEPPER_FORM, action) {
  switch (action.type) {
    case GET_FIELDS:
      return { ...state };
    case UPDATE_COUNTY_FIELD: //used for updating county field
      return updateCountyField(state, action.payload);
    case UPDATE_OPTIONS_TO_FIELDS: //used for updating options to fields
      return updateOptionsToFields(state, action.payload);
    default:
      return state;
  }
}

function updateCountyField(state, payload) {
  const { name, required } = payload;
  let _temp = state[1];
  _temp.fields = _temp.fields.map(fld => {
    if (name === fld.name) {
      if (required) {
        delete fld.required;
      } else {
        fld.required = false;
      }
    }
    return fld;
  });
  state[1] = _temp;
  return { ...state };
}

export function updateOptionsToFields(state, payload) {
  const { name, options } = payload;
  let _state = cloneDeep(state);
  let _temp = _state[1];
  _temp.fields = _temp.fields.map(fld => {
    if (name === fld.name) {
      fld.options = options;
    }
    return fld;
  });
  _state[1] = _temp;
  return _state;
}


export function resetFieldsOptions(state, payload) {
  const { name, options } = payload;
  let _state = cloneDeep(state);
  let _temp = _state[1];
  _temp.fields = _temp.fields.map(fld => {
    if (name === fld.name) {
      fld.options = options;
    }
    return fld;
  });
  _state[1] = _temp;
  return _state;
}